export default "__VITE_ASSET__aiVHe9qB__"